import { BackgroundImageHeader } from "features/fortune-tellers/components/BackgroundImageHeader";
import { AchievementRow } from "shared/components/molecules/AchievementRow";
import { StarRating } from "shared/components/molecules/StarRating";
import { StatusLabel } from "shared/components/molecules/StatusLabel";
import { FortuneTeller } from "shared/types";
import { Skeleton } from "shared/components/atoms/Skeleton";
import { DivinationList } from "./DivinationList";
import { useCalledFortuneTeller } from "repositories/hooks/useCalledFortuneTeller";
import { RecentOrderCard } from "features/Home/components/v2/RecentOrderCard";

interface Props {
  fortuneTeller: FortuneTeller;
}

/**
 * @param fortuneTeller [FortuneTeller]
 */
export const FortuneTellerProfile = ({ fortuneTeller }: Props) => {
  const { fortuneTeller: calledFortuneTeller } = useCalledFortuneTeller(
    fortuneTeller?.id
  );

  return (
    <>
      <BackgroundImageHeader fortuneTeller={fortuneTeller} />
      <div tw="mx-5">
        <div tw="mt-[62px]">
          {fortuneTeller?.name ? (
            <h2 tw="font-base text-lg leading-[18px] tracking-[.53px] text-center">
              {fortuneTeller.name}
            </h2>
          ) : (
            <Skeleton tw="w-2/5 h-3 rounded" />
          )}
        </div>
        <StatusLabel tw="mt-3" fortuneTeller={fortuneTeller} />
        <div tw="flex justify-center mt-2">
          <StarRating rate={fortuneTeller?.averageScore ?? 0} size="large" />
          <div tw="font-base text-xs font-light tracking-[.3px] leading-none text-secondary ml-1">
            ({fortuneTeller?.reviewCounts ?? 0})
          </div>
        </div>
        <AchievementRow tw="mt-3" data={fortuneTeller?.achievement} />
        {calledFortuneTeller && (
          <RecentOrderCard fortuneTeller={calledFortuneTeller} tw="mt-6" />
        )}
      </div>
      <DivinationList tags={fortuneTeller?.divinationTags} />
    </>
  );
};
